var React = require('react');

function BlobTwo (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(300,300)"},React.createElement("path",{"d":"M131.8,-187.7C173.5,-178.3,211.8,-146.3,225.4,-106C239,-65.8,227.9,-17.3,207.6,20.3C187.3,57.9,157.9,84.6,134.3,122.1C110.7,159.6,93,207.9,62.5,220.2C32,232.5,-11.2,208.8,-48.5,187.7C-85.9,166.5,-117.4,147.7,-153,123.3C-188.7,98.9,-228.5,68.7,-221.8,38.9C-215.2,9.1,-162.2,-20.4,-130,-46.3C-97.8,-72.2,-86.5,-94.6,-68.3,-114.8C-50.1,-135,-25,-153,10,-168.5C45.1,-184.1,90.1,-197.2,131.8,-187.7Z","fill":"currentColor"})));
}

BlobTwo.defaultProps = {"width":"600","height":"600","viewBox":"0 0 600 600"};

module.exports = BlobTwo;

BlobTwo.default = BlobTwo;
